<template>
    <div :class="{ loader: true, fadeout: !isloading }">
      <div class="splash">
        <img src="../../assets/loder.gif" style="width:50%; "/>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "loadingscreen",
    props: ["isloading"]
  };
  </script>
  
  <style>
  
  .loader {
    background-color: #ffffff;
    bottom: 0;
    color: white;
    display: block;
    font-size: 32px;
    left: 0;
    overflow: hidden;
    padding-top: 10vh;
    position: fixed;
    right: 0;
    text-align: center;
    z-index: 999999;
    top: 0;
  }
  
  .fadeout {
    animation: fadeout 5s forwards;
  }
  
  @keyframes fadeout {
    to {
      opacity: 1;
      visibility: hidden;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/SplashScreen/LoadingScreen.vue